<template>
  <v-container fluid>
      <div class="about-section">
        <div class="center">
          <h2>{{ $t("app.about.app") }}</h2>
          <p v-html="$t('app.about.text')"></p>
        </div>
        <a
          href="https://www.mothchi.eu/service/5/16"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ListItem last="true">{{ $t("app.about.more") }}</ListItem>
        </a>
      </div>

      <div class="about-section">
        <div class="center">
          <h2>{{ $t("app.about.version") }}</h2>
          <p>
            {{ $t("app.about.current") }}:
            <span class="pink--text">v{{ gitVersion}}</span>
          </p>
        </div>
      </div>

      <div class="about-section">
        <div class="center">
          <h2>{{ $t("app.about.partners") }}</h2>
          <div class="logo-container">
            <img
              class="logo-entry"
              :src="require(`@/assets/images/odisee-logo.png`)"
              alt="Odisee partner logo"
            />
            <img
              class="logo-entry"
              src="https://leapsitestorage.blob.core.windows.net/sitecontent/logo_300_f760587a37.png"
              alt="LeapStation partner logo"
            />

          </div>
        </div>
      </div>
  </v-container>
</template>

<script>
export default {
  name: "neoparent-about",
  props: ['git-version']
};
</script>

<style scoped lang="scss">
.logo-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px; /* Optional: Adds space between logos */
}

.logo-entry {
  max-height: 100px;
  width: auto;
  height: auto;
}
</style>
